import React, {Component} from "react";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {CONFIG, SERVICE} from "../config";
import EkspedisiDetailContent from "./ekspedisiDetailContent";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {getUserAccess} from "../../../../Services/Utils";
import {removeNullFields} from "../../../common/mapper";

class EkspedisiContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // tableColumns: this.getTableColumns(props.tab),
            selectedData: null,
            searchKey: null,
            searchValue: null,
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            },
            isFetch: false,
            userAccess: {},
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        if (this.props.selectedCabang) {
            await this.fetchData();
        }
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (!R.equals(prevProps.selectedCabang, this.props.selectedCabang)) {
            this.handleTriggerLoading();
            await this.setState((prevState) => ({
                ...prevState,
                isFetch: true,
                pagination: {
                    ...prevState.pagination,
                    count: 0,
                    limit: 5,
                    page: 1,
                }
            }));
            await this.fetchData();
            this.handleTriggerLoading();
        }
        if ((prevState.pagination.limit !== this.state.pagination.limit ||
                prevState.pagination.page !== this.state.pagination.page) &&
            !this.state.isFetch) {
            this.handleTriggerLoading();
            await this.fetchData();
            this.handleTriggerLoading();
        }
        if (prevState.searchKey !== this.state.searchKey && R.isNil(this.state.searchKey)) {
            this.setState((prevValue) => ({...prevValue, searchValue: null}));
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
                count: 0,
            },
        }));
    };

    handleChangeRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
                count: 0,
            },
        }));
    };

    getTableColumns(tab) {
        let columns = [...CONFIG.TABLE_COLUMN];
        if (tab === CONFIG.TAB.BELUM_EKSPEDISI) {
            columns.push({
                name: "action",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => (
                        <FlexView hAlignContent="center" style={{ gap: 10 }}>
                            <SimpleButton
                                type="button"
                                className="btnAct"
                                category="action_button"
                                icon={<i className={"fa fa-file-signature"} style={{fontSize: 20, color: this.state.userAccess?.createAccess ? "red" : "black"}}/>}
                                onClick={() => this.handleModalDetailVisibility(tableMeta.rowIndex, "proses")}
                                disabled={!this.state.userAccess?.createAccess}
                            />
                             <SimpleButton
                                type="button"
                                className="btnAct"
                                category="action_button"
                                icon={<i className={"fa fa-lw fa-pencil-alt"} style={{fontSize: 20, color: this.state.userAccess?.updateAccess ? "red" : "black"}}/>}
                                onClick={() => this.handleModalDetailVisibility(tableMeta.rowIndex, "edit")}
                                disabled={!this.state.userAccess?.updateAccess}
                            />
                        </FlexView>
                    ),
                },
            })
        } else {
            const additionalColumns = [
                {name: "nomorEkspedisi", label: "No. Ekspedisi"},
                {name: "tanggalEkspedisi", label: "Tanggal Ekspedisi"},
            ];
            const iconName = this.props.isMenyusul ? "fa fa-file-signature" : "fa fa-lg fa-eye"
            columns.splice(4, 0, ...additionalColumns);
            columns.push({
                name: "action",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => (
                        <>
                            <SimpleButton
                                type="button"
                                className="btnAct"
                                category="action_button"
                                icon={<i className={iconName} style={{fontSize: 20, color:"red"}}/>}
                                onClick={() => this.handleModalDetailVisibility(tableMeta.rowIndex, "read")}
                            />
                        </>
                    ),
                },
            })
        }

        return columns;
    }

    handleModalDetailVisibility = (index, action) => {
        this.setState((prevState) => ({
            ...prevState,
            selectedData: !R.isNil(index) ? {...prevState.dataTable[index]} : null,
            modalDetailVisible: !prevState.modalDetailVisible,
            action: action
        }));
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        let statusEkspedisi = R.equals(this.props.tab, CONFIG.TAB.BELUM_EKSPEDISI) ? ["DRAFT"] : this.props.isMenyusul ? ["MENYUSUL"] : ["PROSES", "SELESAI", "TOLAK", "CANCEL"];
        let req = {
            paramFilters: {
                kodeCabang: this.props.selectedCabang?.value,
                statusEkspedisi: statusEkspedisi,
                ...(this.state.searchKey?.value ? {[this.state.searchKey.value]: this.state.searchValue} : {})
            },
            page: 1,
            limit: this.state.pagination.limit,
        }
        await this.fetchData(req);
        this.handleTriggerLoading();
    }

    handleSubmitProses = async (reqBody) => {
        this.handleTriggerLoading();
        let res = await SERVICE[this.props.tab].proses(this.props.setError, reqBody);
        console.log(res);
        this.handleModalDetailVisibility();
        await this.setState((prevState) => ({
            ...prevState,
            isFetch: true,
            searchKey: null,
            searchValue: null,
            pagination: {
                ...prevState.pagination,
                count: 0,
                limit: this.state.pagination.limit,
                page: this.state.pagination.page,
            }
        }));
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (body) => {
        this.setState((prevState) => ({...prevState, isFetch: true}));
        let statusEkspedisi = R.equals(this.props.tab, CONFIG.TAB.BELUM_EKSPEDISI) ? ["DRAFT"] : this.props.isMenyusul?["MENYUSUL"] : ["PROSES", "SELESAI", "TOLAK", "CANCEL"];
        let req = body && Object.keys(body).length > 0 ? body : {
            paramFilters: {
                kodeCabang: this.props.selectedCabang?.value,
                statusEkspedisi: [...statusEkspedisi],
                ...(this.state.searchKey?.value ? {[this.state.searchKey.value]: this.state.searchValue} : {}),
            },
            page: this.state.pagination.page,
            limit: this.state.pagination.limit,
        };

        let userAccess = getUserAccess(this.props.menuAccess, this.props.selectedCabang?.value);

        let res = await SERVICE[this.props.tab].getAll(this.props.setError, removeNullFields(req));
        if (res.ok && R.equals(res?.data?.status, "S")) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                },
                userAccess
            }));
        }
        this.setState((prevState) => ({...prevState, isFetch: false}));
    };

    render() {
        return (
            <>
                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                    <p className="margin-bottom-20px">Pilih: </p>
                    <SimpleDDL
                        id="select_options_search"
                        box="search"
                        name="searchKey"
                        containerclassname="width width-250px"
                        menuPosition="fixed"
                        options={[
                            {label: "Kode Varian", value: "kodeVarian"},
                            {label: "Nomor Mesin", value: "nomorMesin"},
                        ]}
                        isClearable={true}
                        value={this.state.searchKey}
                        onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                    />
                    <p className="margin-bottom-20px">Cari: </p>
                    <SimpleInput
                        type="text"
                        name="searchValue"
                        value={this.state.searchValue}
                        readOnly={!this.state.searchKey}
                        onChange={(e) => this.handleSearchValueChange(e.target.name, e.target.value)}
                    />
                    <SimpleButton
                        text="Cari"
                        className="margin-bottom-15px"
                        onClick={this.handleSubmitSearch}
                    />
                </FlexView>

                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.getTableColumns(this.props.tab)}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                />

                {this.state.modalDetailVisible && (
                    <EkspedisiDetailContent
                        {...this.props}
                        userAccess={this.state.userAccess}
                        tab={this.props.tab}
                        actionType={this.state.action}
                        selectedData={this.state.selectedData}
                        visible={this.state.modalDetailVisible}
                        onClickClose={this.handleModalDetailVisibility}
                        onSubmitProses={this.handleSubmitProses}
                    />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(EkspedisiContent);